import { type OpportunitiesSearchViewModel } from '@/features/opportunities/OpportunitiesSearchViewModel'
import { observer } from 'mobx-react-lite'
import { WorkspaceSelectorViewHeadingContainer } from '@/features/iam/workspaces/components/WorkspaceSelectorViewHeading/WorkspaceSelectorViewHeadingContainer'
import { type Workspace } from '@/features/iam/workspaces/Workspace'
import { type MotionValue } from 'motion/react'
import { useAnimationProgress } from '@/contexts/animation-progress-context'

export interface OpportunitiesViewHeadingContainerProps {
  viewTitle: string
  allOptionText?: string
  vm: OpportunitiesSearchViewModel
  workspaces: Workspace[]
  compactionAnimationProgress?: MotionValue<number>
}

export const OpportunitiesViewHeadingContainer = observer(
  function OpportunitiesViewHeadingContainer({
    vm,
    viewTitle,
    allOptionText,
    workspaces,
    compactionAnimationProgress,
  }: OpportunitiesViewHeadingContainerProps) {
    compactionAnimationProgress = useAnimationProgress(
      compactionAnimationProgress,
    )
    return (
      <WorkspaceSelectorViewHeadingContainer
        primaryText={viewTitle}
        allOptionText={allOptionText ?? null}
        workspaces={workspaces}
        compactionAnimationProgress={compactionAnimationProgress}
        onChange={vm.selectWorkspaceForFiltering}
        value={vm.selectedWorkspace}
      />
    )
  },
)
